import React from 'react'
import StandBy from '../../components/common/StandBy'

function MensualidadInfo() {
  return (
    <StandBy />
  )
}

export default MensualidadInfo